import { render } from "./all-course.vue?vue&type=template&id=b0492764&scoped=true"
import script from "./all-course.vue?vue&type=script&lang=js"
export * from "./all-course.vue?vue&type=script&lang=js"

import "./all-course.vue?vue&type=style&index=0&id=b0492764&lang=scss&scoped=true"

import exportComponent from "E:\\my-work\\company\\product\\yuanxi\\yuanxi-zju\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0492764"]])

export default __exports__